import { useEffect } from 'react'
import { useCurrentHealthCenter } from '../../components/AppShell'
import { trackEvent } from '../../lib/config'
import { ButtonAnchor, PageHeading, Panel } from '../../components/common'

const ACCOUNT_ROWS: readonly [string, string][] = [
  ['Nombre', 'GLB Inversiones SpA'],
  ['Banco', 'Banco Estado'],
  ['Tipo de cuenta', 'Cuenta Vista (o Chequera Electrónica)'],
  ['Número de cuenta', '33670393955'],
  ['RUT', '76.901.086-6'],
  ['Email', 'contacto@historiaclinica.cl'],
]

export default function ElectronicTransferPage() {
  const healthCenter = useCurrentHealthCenter()

  useEffect(() => {
    trackEvent('Transfer Instructions Viewed')
  }, [])

  if (!healthCenter) {
    return null
  }

  return (
    <div className="row" style={{ paddingTop: 10 }}>
      <div className="col-md-8 col-md-offset-2 col-xs-12">
        <Panel style={{ marginTop: 10 }}>
          <div className="well" style={{ border: 'none', boxShadow: '0 0px' }}>
            <div className="row">
              <PageHeading>Datos de nuestra cuenta</PageHeading>
              <div className="col-sm-10 col-sm-offset-1">
                <p style={{ textAlign: 'center' }} />
              </div>
              <div className="col-sm-10 col-sm-offset-1">
                <p style={{ textAlign: 'center' }}>
                  Si el rut del dueño de la cuenta bancaria no es el mismo que el del administrador del centro médico, asegurate de
                  indicar tus datos en la descripción de la transferencia.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
                <div className="tab-pane active">
                  <table className="table table-responsive">
                    <tbody>
                      {ACCOUNT_ROWS.map(([label, value], index) => (
                        <tr key={label}>
                          <td style={{ width: '40%', ...(index === 0 ? { borderTop: 0 } : {}) }}>{label}</td>
                          <td style={{ textAlign: 'right', ...(index === 0 ? { borderTop: 0 } : {}) }}>{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row" style={{ textAlign: 'center' }}>
              <ButtonAnchor href={`/health_centers/${healthCenter.id}/payments`}>Ir historial</ButtonAnchor>
              <ButtonAnchor href={`/professionals/health_centers/${healthCenter.id}/edit`}>Ir a mi perfil</ButtonAnchor>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  )
}
